<template>
  <SysDialog
    v-model="DIALOG_ATIVO"
    :titulo="`Relatório ${relatorio.title}`"
    txt-botao="Gerar relatório"
    :largura="750"
    @click:primary="gerarRelatorio"
  >
    <div class="d-flex align-center mt-4">
      <div class="w-50-porcento pr-1">
        <SysGrupoAutocomplete
          v-model="filtros.grupos"
          label="Grupos"
          outlined
          multiple
          hide-details
        />
      </div>

      <div class="w-50-porcento pl-1">
        <SysFilialGrupoAutocomplete
          v-model="filtros.filiais"
          label="Filial"
          outlined
          hide-details
          multiple
          :ids-grupo="filtros.grupos"
        />
      </div>
    </div>

    <div class="d-flex align-center">
      <div class="w-50-porcento pr-1">
        <SysSegmentoAutocomplete
          v-model="filtros.segmentos"
          label="Segmentos"
          outlined
          multiple
          hide-details
          class="mt-4"
        />
      </div>

      <div class="w-50-porcento pl-1">
        <SysFornecedorAutocomplete
          v-model="filtros.fornecedores"
          label="Fornecedores"
          outlined
          multiple
          :ids-segmento="filtros.segmentos"
          hide-details
          class="mt-4"
        />
      </div>
    </div>

    <div class="d-flex align-center mt-2">
      <div class="w-50-porcento pr-1 ">
        <SysHistogramaPersonalizadoAutocomplete
          v-model="filtros.histogramas"
          :input_value="inputHistogramas"
          label="Histogramas"
          return-object
          multiple
          outlined
          :qtdeVisivelSelecionados="1"
          class="mt-2"
        />
      </div>

      <div class="w-50-porcento mt-n5">
        <SysCompradorAutocomplete
          v-model="filtros.compradores"
          label="Compradores"
          multiple
          outlined
          :qtde_visivel_selecionados="1"
          hide-details
          class="pl-1"/>
      </div>
    </div>

    <DivisorComLegenda legenda="Flags" class="mb-5 mt-n2"/>

    <div class="mt-4">
      <div class="d-flex align-center mr-3 mb-3">
        <v-switch
          v-model="filtros.apenas_pedidos_faturados"
          hide-details
          color="#a71830"
        >
          <template #label>
            <span class="pl-2">Apenas pedidos faturados</span>
          </template>
        </v-switch>
      </div>

      <div class="d-flex align-center">
        <v-switch
          v-model="filtros.apenas_qtde_pendente_maior_que_zero"
          hide-details
          color="#a71830"
        >
          <template #label>
            <span class="pl-2">Somente Pedidos pendentes</span>
          </template>
        </v-switch>
      </div>
    </div>
  </SysDialog>
</template>

<script>
import SysHistogramaPersonalizadoAutocomplete from "@/components/utils/crud/SysHistogramaPersonalizadoAutocomplete.vue";
import SysFilialGrupoAutocomplete from "@/components/utils/crud/SysFilialGrupoAutocomplete";
import SysFornecedorAutocomplete from "@/components/utils/crud/SysFornecedorAutocomplete";
import SysSegmentoAutocomplete from "@/components/utils/crud/SysSegmentoAutocomplete";
import DivisorComLegenda from "@/components/utils/DivisorComLegenda.vue";
import Mixin from "@/components/Relatorios/Mixin";
import $axios from "@/api/api";
import SysCompradorAutocomplete from "@/components/utils/crud/SysCompradorAutocomplete.vue";
import SysGrupoAutocomplete from "@/components/utils/crud/SysGrupoAutocomplete.vue";

export default {
  name: "PedidosPendentes",
  mixins: [Mixin],
  components: {
    SysGrupoAutocomplete,
    SysCompradorAutocomplete,
    SysHistogramaPersonalizadoAutocomplete,
    DivisorComLegenda,
    SysFornecedorAutocomplete,
    SysSegmentoAutocomplete,
    SysFilialGrupoAutocomplete
  },
  data: () => ({
    filtros: {
      grupos: [],
      compradores: [],
      filiais: [],
      segmentos: [],
      fornecedores: [],
      histogramas: [],
      apenas_pedidos_faturados: false,
      apenas_qtde_pendente_maior_que_zero: true,
      exportacao_relatorio_excel: 'S'
    },
    selects: {
      dias: [
        { valor: 1, descricao: '1. Menor que 90 dias' },
        { valor: 2, descricao: '2. Entre 90 e 180 dias' },
        { valor: 3, descricao: '3. Maior que 180 dias' },
      ]
    },
    inputHistogramas: [
      { id: 1, inicio: 0, fim: 30, descricao: 'Até 30 dias em aberto' },
      { id: 2, inicio: 31, fim: 60, descricao: 'De 31 a 60 dias em aberto' },
      { id: 3, inicio: 61, fim: 90, descricao: 'De 61 a 90 dias em aberto' },
      { id: 4, inicio: 90, fim: 0, descricao: 'Acima de 91 dias em aberto' },
    ]
  }),
  computed: {},
  methods: {
    gerarRelatorio() {
      const form = document.createElement('form');

      form.setAttribute('action', $axios.defaults.baseURL + '/relatorios/dashboard/pedidos-pendentes/exportar-relatorio-excel');
      form.setAttribute('method', 'POST');
      form.setAttribute('target', '_blank');
      form.setAttribute('style', 'display: none;');

      const filtros = { ...this.filtros };

      if (filtros.histogramas) {
        filtros.histogramas = JSON.stringify(filtros.histogramas);
      }

      Object.keys(filtros).forEach(key => {
        const input = document.createElement('input');
        input.setAttribute('type', 'hidden');
        input.setAttribute('name', key);
        input.setAttribute('value', filtros[key]);
        form.appendChild(input);
      });

      document.body.appendChild(form);
      form.submit();

      form.remove();

      this.DIALOG_ATIVO = false;
    }
  }
}
</script>
